import { useState } from 'react';
import { InputGroup, InputRightElement, InputLeftElement, Input, Tooltip, Button, Icon } from '@chakra-ui/react';
import { getIcon } from 'lib/icons';
import { FC } from 'react';
import { AiOutlineEye } from '@react-icons/all-files/ai/AiOutlineEye';
import { AiOutlineEyeInvisible } from '@react-icons/all-files/ai/AiOutlineEyeInvisible';

// TODO: Type declarations
type Props = {
  schema: any;
  field: any;
}

export const InputPassword: FC<Props> = ({ schema, field }) => {
  const [show, setShow] = useState<boolean>(false);
  const handleClick = (): void => setShow(!show);

  return (
    <InputGroup size="md">
      <InputLeftElement height="100%" width="30px" ml="15px">
        {getIcon(schema.icon)}
      </InputLeftElement>
      <Input
        pr="2rem"
        pl="4rem"
        size="lg"
        {...schema}
        {...field}
        type={show ? "text" : "password"}
      />
      <InputRightElement mr="15px" height="100%">
        {show ? (
          <Tooltip label="Hide password">
            <Button onClick={handleClick}>
              <Icon boxSize="24px" as={AiOutlineEye}/>
            </Button>
          </Tooltip>
          ) : (
          <Tooltip label="Show password">
            <Button colorScheme="brand" onClick={handleClick}>
              <Icon boxSize="24px" as={AiOutlineEyeInvisible} />
            </Button>
          </Tooltip>
        )}
      </InputRightElement>
    </InputGroup>
  )
};
